// app/src/pages/RedirectPage.tsx
import React, { FC, useEffect } from 'react';


const RedirectPage: FC = () => {
	useEffect(() => {
		const getCookie = (name: string) => {
			const value = `; ${document.cookie}`;
			const parts = value.split(`; ${name}=`);
			if (parts.length === 2) return parts.pop()?.split(';').shift();
		};
		
		const redirectUrl = getCookie('redirectUrl');
		
		if (redirectUrl) {
			document.cookie = 'redirectUrl=; Max-Age=0; path=/';
			
			window.location.href = decodeURIComponent(redirectUrl);
		} else {
			console.error('Aucune URL de redirection trouvée.');
		}
	}, []);
	
	return (<></>);
};


export default RedirectPage;
